/* BASIC APP CONSTANTS */
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const APP_COOKIE_NAME = "APP_COOKIE_NAME";
export const USER_COOKIE_NAME = "USER_COOKIE_NAME";
export const PASS_COOKIE_NAME = "PASS_COOKIE_NAME";
export const USER_ID_COOKIE_NAME = "USER_ID_COOKIE_NAME";
export const SET_CURRENT_ROUTE = "SET_CURRENT_ROUTE";
export const SET_SIDE_MENU_STATE = "SET_SIDE_MENU_STATE";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";
export const SHOW_ACTION_MENU = "SHOW_ACTION_MENU";
export const HIDE_ACTION_MENU = "HIDE_ACTION_MENU";
export const SHOW_BOTTOM_TOOLBAR = "SHOW_BOTTOM_TOOLBAR";
export const HIDE_BOTTOM_TOOLBAR = "HIDE_BOTTOM_TOOLBAR";
export const SET_USER_LIST = "SET_USER_LIST";
export const EDIT_DISABLED_BUTTONS = "EDIT_DISABLED_BUTTONS";
export const SET_LOGS_LIST = "SET_LOGS_LIST";
export const THEME = "THEME";
export const SET_PROJECTSNAV_LIST = "SET_PROJECTSNAV_LIST";


/* <---- BASIC APP CONSTANTS ----> */

/* SOCKET CONSTANTS */
export const CONNECTED = "connected";
export const DISCONNECTED = "disconnected";
/* <---- SOCKET CONSTANTS ----> */

/* CONFIGURATION */
export const CONFIGURATION_FORM_TOOGLE_LOADING =
  "CONFIGURATION_FORM_TOOGLE_LOADING";
export const SET_CONFIGURATION = "SET_CONFIGURATION";
/* <---- CONFIGURATION ----> */

/* USER */
export const SET_PROFILE = "SET_PROFILE";
/* <---- USER ----> */

/* USERS */
export const ADD_NEW_USER = "ADD_NEW_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const OPEN_USERS_FORM = "OPEN_USERS_FORM";
export const CLOSE_USERS_FORM = "CLOSE_USERS_FORM";
export const EDIT_SELECTED_USER = "EDIT_SELECTED_USER";
export const USERS_FORM_TOOGLE_LOADING = "USERS_FORM_TOOGLE_LOADING";
/* <---- USERS ----> */

/* TICKET */
export const SET_TICKET_LIST = "SET_TICKET_LIST";
export const ADD_NEW_TICKET = "ADD_NEW_TICKET";
export const UPDATE_TICKET = "UPDATE_TICKET";
export const DELETE_TICKET = "DELETE_TICKET";
export const OPEN_TICKET_FORM = "OPEN_TICKET_FORM";
export const CLOSE_TICKET_FORM = "CLOSE_TICKET_FORM";
export const EDIT_SELECTED_TICKET = "EDIT_SELECTED_TICKET";
export const TICKET_FORM_TOOGLE_LOADING = "TICKET_FORM_TOOGLE_LOADING";
/* <---- TICKET ----> */

/* APPLICATION */
export const SET_APPLICATION_LIST = "SET_APPLICATION_LIST";
export const ADD_NEW_APPLICATION = "ADD_NEW_APPLICATION";
export const UPDATE_APPLICATION = "UPDATE_APPLICATION";
export const DELETE_APPLICATION = "DELETE_APPLICATION";
export const OPEN_APPLICATION_FORM = "OPEN_APPLICATION_FORM";
export const CLOSE_APPLICATION_FORM = "CLOSE_APPLICATION_FORM";
export const EDIT_SELECTED_APPLICATION = "EDIT_SELECTED_APPLICATION";
export const APPLICATION_FORM_TOOGLE_LOADING = "APPLICATION_FORM_TOOGLE_LOADING";
/* <---- APPLICATION ----> */

/* ROUTES */
export const SET_ALL_ROUTES = "SET_ALL_ROUTES";
export const UPDATE_ROUTE = "UPDATE_ROUTE";
/* <---- ROUTES ----> */

/* ALERT */
export const SET_ALERT_LIST = "SET_ALERT_LIST";
export const ADD_NEW_ALERT = "ADD_NEW_ALERT";
export const UPDATE_ALERT = "UPDATE_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const OPEN_ALERT_FORM = "OPEN_ALERT_FORM";
export const CLOSE_ALERT_FORM = "CLOSE_ALERT_FORM";
export const EDIT_SELECTED_ALERT = "EDIT_SELECTED_ALERT";
export const ALERT_FORM_TOOGLE_LOADING = "ALERT_FORM_TOOGLE_LOADING";
/* <---- ALERT ----> */

/* IMPUTHOUR */
export const SET_IMPUTHOUR_LIST = "SET_IMPUTHOUR_LIST";
export const ADD_NEW_IMPUTHOUR = "ADD_NEW_IMPUTHOUR";
export const UPDATE_IMPUTHOUR = "UPDATE_IMPUTHOUR";
export const DELETE_IMPUTHOUR = "DELETE_IMPUTHOUR";
export const OPEN_IMPUTHOUR_FORM = "OPEN_IMPUTHOUR_FORM";
export const CLOSE_IMPUTHOUR_FORM = "CLOSE_IMPUTHOUR_FORM";
export const EDIT_SELECTED_IMPUTHOUR = "EDIT_SELECTED_IMPUTHOUR";
export const IMPUTHOUR_FORM_TOOGLE_LOADING = "IMPUTHOUR_FORM_TOOGLE_LOADING";
/* <---- IMPUTHOUR ----> */

/* PROJECT */
export const SET_PROJECT_LIST = "SET_PROJECT_LIST";
export const ADD_NEW_PROJECT = "ADD_NEW_PROJECT";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const OPEN_PROJECT_FORM = "OPEN_PROJECT_FORM";
export const CLOSE_PROJECT_FORM = "CLOSE_PROJECT_FORM";
export const EDIT_SELECTED_PROJECT = "EDIT_SELECTED_PROJECT";
export const PROJECT_FORM_TOOGLE_LOADING = "PROJECT_FORM_TOOGLE_LOADING";
/* <---- PROJECT ----> */
